import Vue from 'vue'
import { cloneDeep } from 'lodash'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'
import { singularize } from '@/utilities'

export const WorkflowSharedState = {
  workflowSharedCachedList: [],
  workflowSharedDialogShow: false,
  workflowSharedList: [],
  workflowSharedModified: false,
  workflowSharedPermissions: {},
}

export const DEFAULT_WORKFLOW_PERMISSIONS = { editors: [], skippers: [] }

export const WorkflowSharedActions = {
  fetchWorkflowSharedDetails: async ({ commit }, { model, id }) => {
    return axiosRequest.
      get(`/${model}/${id}`).
      then(({ data }) => {
        const singular = singularize(model)
        const modelData = data[singular] || data

        commit('setWorkflowSharedPermissions', modelData.workflow_permission || DEFAULT_WORKFLOW_PERMISSIONS)
        commit('setWorkflowSharedList', cloneDeep(modelData.workflows) || [])
      }).
      catch(handleError)
  },
  clearWorkflowSharedDetails: ({ commit }) => {
    commit('setWorkflowSharedModified', false)
    commit('setWorkflowSharedPermissions', DEFAULT_WORKFLOW_PERMISSIONS)
    commit('setWorkflowSharedList', [])
  },
}

export const WorkflowSharedMutations = {
  setWorkflowSharedPermissions: (state, payload) => { state.workflowSharedPermissions = payload },
  setWorkflowSharedList: (state, payload) => { Vue.set(state, 'workflowSharedList', payload) },
  setWorkflowSharedModified: (state, payload) => { state.workflowSharedModified = payload },
  setWorkflowSharedDialogShow: (state, payload) => { state.workflowSharedDialogShow = payload },
  removeWorkflowSharedListItem: (state, payload) => { state.workflowSharedList.splice(payload, 1) },
  setWorkflowsSharedItemInDays: (state, { workflowIndex, inDays }) => {
    const workflow = state.workflowSharedList[workflowIndex]
    Vue.set(state.workflowSharedList, workflowIndex, { ...workflow, in_days: inDays })
  },
}

export const WorkflowSharedGetters = {
  getWorkflowSharedList: state => state.workflowSharedList,
  getWorkflowSharedModified: state => state.workflowSharedModified,
  getWorkflowSharedDialogShow: state => state.workflowSharedDialogShow,
  getWorkflowEditors: state => state.workflowSharedPermissions?.editors || [],
  getWorkflowSkippers: state => state.workflowSharedPermissions?.skippers || [],
  userCanEditWorkflows: (state, _, rootGetters) => {
    const user = rootGetters.currentUser

    return state.workflowSharedPermissions?.editors?.includes(user.id) ||
      (state.workflowSharedPermissions?.editors?.includes('all_editors') && user.atleastEditor) ||
      (state.workflowSharedPermissions?.editors?.includes('all_contributors') && user.atleastContributor) ||
      (state.workflowSharedPermissions?.editors?.includes('all_admins') && user.isAdmin)
  },
  userCanSkipWorkflows: (state, _, rootGetters) => {
    const user = rootGetters.currentUser

    return state.workflowSharedPermissions?.skippers?.includes(user.id) ||
      (state.workflowSharedPermissions?.skippers?.includes('all_editors') && user.atleastEditor) ||
      (state.workflowSharedPermissions?.skippers?.includes('all_contributors') && user.atleastContributor) ||
      (state.workflowSharedPermissions?.skippers?.includes('all_admins') && user.isAdmin)
  },
}
